/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { DeviceTransactions } from '../../../../app/pages/js/DeviceTransaction'
import { getRequest, postRequest } from './../../../../app/pages/Helpers/Requests'
import TransactionDetailsModal from '../../../../app/pages/Components/TransactionDetailsModal'
import ConfirmModal from '../../../../app/modules/Confirmation/ConfirmModal'
import toast from 'react-hot-toast'
type Props = {
  className: String
  DT: {}
  stationId: any
}
export interface dtUpdates {
  config: String
  value: String
  description: String
  access: String
}
export const DTable = {
  id: 'Transaction Id',
  connector: 'Connector Id',
  username: 'UserName',
  start: 'Start Date',
  stop: 'Stop Date',
  duration: 'Duration',
  meter: 'Total Meter value(Wh)',
  platform: 'Platform',
  stopFrom: 'Stop From',
  status: 'Status',
  userId: 'User Id',
}

const TableWidgetDT: React.FC<Props> = ({ className, stationId }) => {
  let { pointId } = useParams()
  // var pid: number = parseInt(pointId);
  const [selectedTransaction, setSelectedTransaction] = useState()
  const [transactions, setTransactions] = useState<any>([])
  const [page, setPage] = useState<number>(1)
  const [limit, setLimit] = useState<number>(8)
  const [pages, setPages] = useState<any>(0)
  const [transactionId, setTransactionId] = useState()

  var result = DeviceTransactions.find(function (e) {
    return e.id == pointId
  })

  const getPlatformStatus = (platform: string) => {
    if (platform === 'IOS') {
      return 'badge fs-7 fw-semibold badge-light-primary'
    } else if (platform === 'ANDROID') {
      return 'badge fs-7 fw-semibold badge-light-info'
    } else if (platform === 'WEB') {
      return 'badge fs-7 fw-semibold badge-light-success'
    } else {
      return 'badge fs-7 fw-semibold badge-light-danger'
    }
  }

  const getDeviceTransactions = async () => {
    try {
      const res = await getRequest(
        '/device-transaction/station/' + stationId + `?page=${page}&limit=${limit}`
      )
      if (res?.status === 200) {
        console.log(res.data)
        setTransactions([...transactions, ...res.data.data])
        console.log("device transaction", res);
        setPages(res.data.pagination.totalPages)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (stationId !== null && stationId !== undefined && stationId !== '') {
      getDeviceTransactions()
    }
  }, [stationId, limit, page])

  const handleSubmit = async () => {
    try {
      let data = { transactionId: transactionId }
      console.log("values ", data);

      const res = await postRequest('/ocpp/remote/stop-transaction/' + stationId, data);
      if (res && res.data) {
        toast.success(res.data.message);
      }
    } catch (error) {
      console.log(error);
      // toast.error(error.response.data.message);
    }
  }

  return (
    <div className={`card ${className}`}>
      <div className='table-responsive'>
        <table className='table table-row-dashed table-striped gy-7 gs-7'>
          <thead>
            <tr className='fw-bold  text-black border-bottom-2 border-gray-200'>
              <th className='min-w-210px'>{DTable.id}</th>
              <th className='min-w-210px'>{DTable.connector}</th>
              <th className='min-w-210px'>{DTable.userId}</th>
              <th className='min-w-210px'>EMSP</th>
              <th className='min-w-210px'>{DTable.start}</th>
              <th className='min-w-210px'>{DTable.stop}</th>
              <th className='min-w-210px'>{DTable.duration + '(Mins)'}</th>
              <th className='min-w-210px'>{DTable.meter}</th>
              <th className='min-w-210px'>Mac Id</th>
              <th className='min-w-210px'>Start SOC</th>
              <th className='min-w-210px'>Stop SOC</th>
              <th className='min-w-210px'>Amount(Rs)</th>
              <th className='min-w-210px'>GST(18%)</th>
              <th className='min-w-210px'>Total(Rs)</th>
              <th className='min-w-210px'>Reason</th>
              <th className='min-w-210px'>Platform</th>
              <th className='min-w-210px'>Stopfrom</th>
              <th className='min-w-210px'>{DTable.status}</th>
              <th className='min-w-210px'>Action</th>
            </tr>
          </thead>
          <tbody>
            {transactions &&
              transactions?.map((transaction: any, index: any) => {
                const updatedAt = new Date(transaction.updatedAt)
                const createdAt = new Date(transaction.createdAt)
                const timeDifference = updatedAt.getTime() - createdAt.getTime()
                const secondsDifference = timeDifference / 1000
                return (
                  <tr key={index}>
                    <td>
                      <a
                        data-bs-toggle='modal'
                        data-bs-target='#transaction_details'
                        className='cursor-pointer text-black'
                        onClick={() => {
                          setSelectedTransaction(transaction.transactionId)
                        }}
                      >
                        {transaction?.transactionId}
                      </a>
                    </td>
                    <td>{transaction?.connectorId}</td>
                    <td>{transaction?.user?.userId || "N/A"}</td>
                    <td>{transaction?.session?.msp?.party_id || "N/A"}</td>
                    <td>{transaction?.startDate}</td>
                    <td>{transaction?.stopDate && transaction?.stopDate}</td>
                    <td>{(secondsDifference / 60).toFixed(1)}</td>
                    <td>{(transaction?.total_wh / 1000).toFixed(3)}</td>
                    <th>{transaction?.macId}</th>
                    <td>{transaction?.startSoc}</td>
                    <td>{transaction?.status == 0 ? '' : transaction?.stopSoc}</td>
                    <td>{transaction?.amount}</td>
                    <td>{transaction?.gst}</td>
                    <td>{transaction?.price}</td>

                    <td>{transaction?.reason}</td>
                    <td>
                      <span className={getPlatformStatus(transaction?.platform)}>
                        {transaction?.platform}
                      </span>
                    </td>
                    <td>
                      <span className={getPlatformStatus(transaction?.stopFrom)}>
                        {transaction?.stopFrom}
                      </span>
                    </td>
                    <td>
                      {transaction?.status == 0 ? (
                        <a href='#' className={`badge fs-7 fw-semibold badge-light-warning  me-3`}>
                          Charging
                        </a>
                      ) : (
                        <a href='#' className={`badge fs-7 fw-semibold badge-light-success  me-3`}>
                          Completed
                        </a>
                      )}
                    </td>
                    <td>
                      {transaction?.status == 0 ? (
                        <button
                          className='btn btn-sm btn-danger     '
                          data-bs-toggle='modal'
                          data-bs-target='#confirm_modal'
                          onClick={() => {
                            setTransactionId(transaction.transactionId)
                          }}
                        >
                          Stop
                        </button>
                      ) : ''
                      }
                    </td>

                  </tr>
                )
              })}
          </tbody>
          <TransactionDetailsModal transactionId={selectedTransaction} />
        </table>
        {pages > page && (
          <div className='d-flex align-items-center  justify-content-center py-3 '>
            <button
              className='btn btn-light-primary  btn-sm '
              aria-label='Show more items'
              onClick={() => {
                setPage(page + 1)
              }}
            >
              <span className='d-flex align-items-center gap-2'>
                More
                <i className='ki-duotone ki-down'>
                  <i className='path1'></i>
                  <i className='path2'></i>
                </i>
              </span>
            </button>
          </div>
        )}
      </div>
      <ConfirmModal
        text='Are you Sure. You want to Stop the Charging? '
        handleSubmit={handleSubmit}
      />
    </div>
  )
}

export { TableWidgetDT }
